import React from 'react';
import TagManager from 'react-gtm-module';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const CardWithSite = ({
  icon,
  altIcon,
  titleIcon,
  titleCaps,
  text,
  classComponent,
  href,
  textButton,
  buttonOnClick,
  testId,
}) => {
	const sendGtmMetricsAndRedirect = () => {
		const titleEnum = {
			'Editar meu site': 'Acesso a plataforma de sites',
			'Fale conosco': 'Acesso a abertura de chamado',
		};
		if (titleCaps in titleEnum) {
			TagManager.dataLayer({
				dataLayer: {
					event: 'trackEvent',
					actionButton: titleEnum[titleCaps],
				},
				dataLayerName: 'Sites',
			});
		}
		buttonOnClick();
	};

	return (
		<StyledCard className={classComponent}>
			<div className="content-header d-flex justify-content-center align-items-center">
				<img src={icon} alt={altIcon} title={titleIcon} className="icon" />
			</div>
			<div className="text-title d-flex justify-content-center align-items-center">
				<h4>{titleCaps}</h4>
			</div>
			<div className="content-body">{text}</div>
			<div className="d-flex justify-content-center align-items-center">
				<button type="button" onClick={sendGtmMetricsAndRedirect}>
					<a href={href} data-test={testId}>
						{textButton}
					</a>
				</button>
			</div>
		</StyledCard>
	);
};

PropTypes.Card = {
	icon: PropTypes.element,
	altIcon: PropTypes.string,
	titleIcon: PropTypes.string,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
	testId: PropTypes.string,
};

export default CardWithSite;
